import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form

import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";
import {
  ConfImageUploadService,
  flattenObject,
  ImageDataModalRequired,
  transformObject,
} from "./constants";
import MultipleImage from "./Components/MultipleImage";

const Elements = () => {
  const route = all_routes;
  const [MainLogo, setMainLogo] = useState([]);
  const [ValveLogo, setValveLogo] = useState([]);
  const [BulletinLogo, setBulletinLogo] = useState([]);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = useForm(); // Set up useForm

  const fetchData = async () => {
    const res = await GetRequest(`${ApiUrl.configuration}${ConfUrl.element}`);
    if (res) {
      setMainLogo([res?.value?.mainLogo]);
      setValveLogo([res?.value?.valveLogo]);
      setBulletinLogo([res?.value?.bulletinLogo]);

      const val = flattenObject(res?.value, "");
      Object.keys(val).forEach((key) => {
        setValue(key, val[key]);
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let Req = transformObject(data);

    if (MainLogo?.length > 0) {
      let imgKey = null;
      if (MainLogo[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(MainLogo[0]?.image);
      }
      Req.mainLogo = {
        key: MainLogo[0]?.key,
        image: imgKey ? imgKey : MainLogo[0]?.image,
      };
    }

    if (ValveLogo?.length > 0) {
      let imgKey = null;
      if (ValveLogo[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(ValveLogo[0]?.image);
      }
      Req.valveLogo = {
        key: ValveLogo[0]?.key,
        image: imgKey ? imgKey : ValveLogo[0]?.image,
      };
    }

    if (BulletinLogo?.length > 0) {
      let imgKey = null;
      if (BulletinLogo[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(BulletinLogo[0]?.image);
      }
      Req.bulletinLogo = {
        key: BulletinLogo[0]?.key,
        image: imgKey ? imgKey : BulletinLogo[0]?.image,
      };
    }

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.element}`,
      Req
    );
    if (resp) {
      navigate(route.jobapplication);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Site Elements</h4>
              {/* <h6>Create new Career</h6> */}
            </div>
          </div>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="row">
                <h4>
                  <u>Main Logo</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="mainLogo"
                    dataSource={MainLogo}
                    setDataSource={setMainLogo}
                    DataRequired={[ImageDataModalRequired.image]}
                    DataLimit={1}
                  />
                </div>
                <h4>
                  <u>Valve Logo</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="valveLogo"
                    dataSource={ValveLogo}
                    setDataSource={setValveLogo}
                    DataRequired={[ImageDataModalRequired.image]}
                    DataLimit={1}
                  />
                </div>
                <h4>
                  <u>Bulletin Logo</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="bulletinLogo"
                    dataSource={BulletinLogo}
                    setDataSource={setBulletinLogo}
                    DataRequired={[ImageDataModalRequired.image]}
                    DataLimit={1}
                  />
                </div>
                <h4 className="mb-4">
                  <u>Navbar</u>
                </h4>
                {[
                  "home",
                  "aboutUs",
                  "turnkey",
                  "productRange",
                  "kurversValves",
                  "quality",
                  "careers",
                  "contactUs",
                ].map((it) => (
                  <div className="col-6" key={it}>
                    <div className="mb-3 add-product">
                      <label className="form-label">{it}</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register(`navbar_${it}`, {
                          required: `${it.toLocaleUpperCase()} is required`,
                        })}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
    </div>
  );
};

export default Elements;
